import AvailabilityDetail from './AvailabilityDetail';

export default AvailabilityDetail;



// WEBPACK FOOTER //
// ./src/scenes/Availabilities/AvailabilityDetail/index.ts